import { render, staticRenderFns } from "./InstorageList.vue?vue&type=template&id=1ccd0e5c"
import script from "./InstorageList.vue?vue&type=script&lang=js"
export * from "./InstorageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports